import { isNumber } from 'designer/component/action/Data'
import objectPath from 'object-path'

export const calTotal = (jsonTable = [], { designContext, uischema }) => {
  let { isUiChanged, setIsUiChanged, setFieldFormData } = designContext
  const tableColumn = uischema.tableColumn || []

  let filterTotalColumn = tableColumn.filter(
    ({ field, totalField = null }) => field && totalField
  )
  filterTotalColumn.forEach(({ field, totalField }) => {
    let total = 0
    jsonTable.forEach((rowData) => {
      let value = objectPath.get(rowData, field)
      if (isNumber(value)) {
        value = Number(value)
        total += value
      }
    })
    total = parseFloat(total.toFixed(2))
    setFieldFormData(totalField.key, total)
    objectPath.set(isUiChanged, totalField.key, { isRender: true })
  })
  setIsUiChanged(isUiChanged)
}
